import "./DepositCmaHelper.scss";
import {IModalService} from "angular-ui-bootstrap";
import {IPromise} from "angular";
import {PortfolioSummary} from "../../portfolio/models/Portfolio";
import {CmaSummary} from "../../portfolio/models/CmaSummary";
import {PortfolioService} from "../../portfolio/service/PortfolioService";

export class DepositCmaHelper {

    public static id = "depositCmaHelper";

    /** @ngInject */
    public constructor(private $uibModal: IModalService, private portfolioService: PortfolioService) {

    }

    public open(portfolioId: number): IPromise<void> {
        const instance = this.$uibModal.open({
            templateUrl: "app/help/deposit-cma/DepositCmaHelper.html",
            backdrop: "static",
            controller: ModalController,
            windowClass: "deposit-cma-helper",
            controllerAs: "ctrl",
            resolve: {
                summary: () => this.portfolioService.cmaDetails(portfolioId)
            }
        });
        return instance.result;
    }
}

export class ModalController {

    /** @ngInject */
    public constructor(public summary: CmaSummary | null) {
    }
}
